import service from "@/store/services/black-list-users-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  blackListUser: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, blackListUser) => {
    state.blackListUser = blackListUser;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((blackListUser) => {
      commit("SET_RESOURCE", blackListUser);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((blackListUser) => {
      commit("SET_RESOURCE", blackListUser);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((blackListUser) => {
      commit("SET_RESOURCE", blackListUser);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  blackListUser: (state) => state.blackListUser,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((blackListUser) => ({
      id: blackListUser.id
    }));
  },
};

const blackListUsers = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default blackListUsers;
